export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7680.3d5a69ea.jpg";